import React from 'react'
import { FiCalendar } from '@react-icons/all-files/fi/FiCalendar'
import { FiCheckCircle } from '@react-icons/all-files/fi/FiCheckCircle'
import { FiSearch } from '@react-icons/all-files/fi/FiSearch'
import { FiTruck } from '@react-icons/all-files/fi/FiTruck'
import styles from './ProcessStrip.module.scss'

const processIcons = {
  search: FiSearch,
  calendar: FiCalendar,
  truck: FiTruck,
  success: FiCheckCircle
}

const ProcessStrip = ({ ariaLabel = 'How speaker rental works', steps }) => (
  <ol className={styles.strip} aria-label={ariaLabel}>
    {steps.map((step, index) => {
      const Icon = processIcons[step.icon] || FiCheckCircle

      return (
        <li key={step.title}>
          <span className={styles.icon}><Icon aria-hidden='true' /></span>
          <span className={styles.copy}>
            <strong>{index + 1}. {step.title}</strong>
            <small>{step.description}</small>
          </span>
        </li>
      )
    })}
  </ol>
)

export default ProcessStrip
